import Vue from "vue";
import Vuex from "vuex";
import {
  getInfo,
  getShipping,
  login,
  logout,
  getUserAddr,
  getActiveInfo,
  getUserActive,
  takePartIn
} from "./api";
import router from "./router";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    solutionActive:"",
    homeData: {},
    cartList: [],
    hadchecked: [], //
    info: {},
    country: {},
    shipping: 0,
    mouseScrollStatus: true,
    loading: false,
    loadingMsg: "",
    payInfoShow: false,
    privacyShow: false,
    salesShow: false,
    refundShow: false,
    payInfo: {},
    auth: "",
    addressData: {},
    // timeout: 1000000000,
    drawInfo: {},
    userDrawInfo: {},
    userInfo: {},
    target: "",
    totalPrice: 0
    // logged: false,
  },
  getters: {
    homeData: state => state.homeData,
    info: state => state.info,
    country: state => state.country,
    shipping: state => state.shipping,
    cartList: state => state.cartList,
    cartTotal: state => {
      return state.cartList.reduce(
        (prev, next) => prev + parseInt(next.num),
        0
      );
    },
    // cartAmount: state => {
    //   return state.cartList
    //     .filter(item => item.checked)
    //     .reduce(
    //       (prev, next) => prev + parseInt(next.num) * parseFloat(next.price),
    //       0
    //     );
    // },
    mouseScrollStatus: state => state.mouseScrollStatus,
    loading: state => state.loading,
    loadingMsg: state => state.loadingMsg,
    payInfoShow: state => state.payInfoShow,
    privacyShow: state => state.privacyShow,
    salesShow: state => state.salesShow,
    refundShow: state => state.refundShow,
    payInfo: state => state.payInfo,
    auth: state => state.auth,
    addressData: state => state.addressData,
    timeout: state => {
      const triggerTime = state.userDrawInfo.trigerTime;
      return triggerTime
        ? new Date(triggerTime).getTime() - new Date().getTime()
        : 0;
    },
    drawInfo: state => state.drawInfo,
    userDrawInfo: state => state.userDrawInfo,
    userInfo: state => state.userInfo,
    // logged: state => state.logged,
    address: state =>
      `${state.addressData.apartmentUnit}, ${state.addressData.streetAddress}, ${state.addressData.city}, ${state.addressData.province}, ${state.addressData.country} ${state.addressData.postCode}`,
    target: state => state.target
  },
  mutations: {
    // 放getter上，没办法实现同步
    cartAmount: state => {
      state.totalPrice = state.cartList
        .filter(item => item.checked)
        .reduce(
          (prev, next) => prev + parseInt(next.num) * parseFloat(next.price),
          0
        );
    },
    setSolutionActive(state, solutionActive){
      state.solutionActive = solutionActive
    },
    // 修改首页信息
    changeHomeData(state, res) {
      let homeData = res.data;
      homeData.productList = homeData.productList.map(ele => ({
        ...ele,
        name: ele.prodName,
        // price: ele.price,
        // prodId: ele.prodId,
        num: 1,
        img: ele.pic
        // productModel: ele.productModel,
        // oriPrice: ele.oriPrice,
      }));
      state.homeData = homeData;
    },
    // 修改购物车(规格)信息，同件商品会产生累加的效果
    // 需要修改
    changeCart(state, item) {
      // console.log(item, 'product');
      const index = state.cartList.findIndex(
        ele => ele.skuName === item.skuName
      );
      if (index != -1) {
        item.num += state.cartList[index].num;
        state.cartList.splice(index, 1, item);
      } else {
        state.cartList.push(item);
      }

      // const index = state.cartList.findIndex(ele => ele.name === item.name);
      // if (index != -1) {
      //   state.cartList.splice(index, 1, item);
      // } else {
      //   state.cartList.push(item);
      // }
    },
    // 根据购物车索引修改购物车的商品数量
    changeCart2(state, item, index) {
      state.cartList[index] = item;
    },
    // 删除购物车的商品
    removeCart(state, index) {
      state.cartList.splice(index, 1);
    },
    // 清空购物车
    clearCart(state) {
      state.cartList = [];
    },
    // 修改用户信息
    changeInfo(state, form) {
      state.info = form;
    },
    // 修改用户国家信息
    changeCountry(state, country) {
      state.country = country;
    },
    // 修改运费
    changeShipping(state, data) {
      state.shipping = data;
    },
    // 修改加载状态
    changeLoading(state, bool) {
      state.loading = bool;
    },
    // 修改加载文字
    changeLoadingMsg(state, msg) {
      state.loadingMsg = msg;
    },
    // 修改滚轮状态
    changeMouseScrollStatus(state, bool) {
      state.mouseScrollStatus = bool;
    },
    // 修改支付信息展示
    changePayInfoShow(state, bool) {
      state.payInfoShow = bool;
    },
    // 修改隐私策略信息展示
    changePrivacyShow(state, bool) {
      state.privacyShow = bool;
    },
    // 修改购物策略展示
    changeSalesShow(state, bool) {
      state.salesShow = bool;
    },
    // 修改退款策略展示
    changeRefundShow(state, bool) {
      state.refundShow = bool;
    },
    // 修改支付信息
    changePayInfo(state, data) {
      state.payInfo = data;
    },
    // 登录
    changeAuthorization(state, data) {
      state.auth = data;
    },
    // 登录
    changeLoginInfo(state, data) {
      state.userInfo = data;
    },
    // 修改用户地址
    changeUserAddr(state, data) {
      state.addressData = data;
    },
    // 倒计时
    changeTimeout(state, timeout) {
      state.timeout = timeout;
    },
    // 修改活动信息
    changeDrawInfo(state, data) {
      state.drawInfo = data;
    },
    // 修改用户活动信息
    changeUserDrawInfo(state, data) {
      state.userDrawInfo = data;
    },
    // 修改用户活动信息
    changeTarget(state, target) {
      state.target = target;
    }
  },
  actions: {
    // 获取首页信息
    // changeHomeDataAsync({ commit }, params) {
    //   commit("changeLoading", true);
    //   getInfo(params)
    //     .then(res => {
    //       commit("changeLoading", false);
    //       if (res.status == 200) {
    //         commit("changeHomeData", res);
    //       }
    //     })
    //     .catch(err => {
    //       commit("changeLoading", false);
    //     });
    // },
    // 获取运费
    changeShippingAsync({ commit, state }) {
      return getShipping({
        prodInfoList: state.cartList
          .filter(item => item.checked === true)
          .map(ele => ({
            prodId: ele.prodId,
            prodNum: ele.num,
            skuId: ele.skuId,
            packageName: ele.skuName.substr(6)
          })),
        zone: state.country.zone
      }).then(res => {
        if (res.status == 200) {
          commit("changeShipping", res.data);
        } else {
          commit("changeShipping", 0);
        }
      });
    },
    // 登录
    changeLoginStatusAsync(
      { commit },
      { password, email, remember, response }
    ) {
      return login({
        credentials: password,
        principal: email,
        response: response,
        remoteip: undefined
      }).then(res => {
        if (res.status == 200) {
          commit("changeLoginInfo", res.data);
          commit("changeAuthorization", "bearer" + res.data.access_token);
        }
        return res;
      });
    },
    // 退出登录
    logoutAsync({ commit }, stay) {
      return logout().then(res => {
        if (res.status == 200) {
          commit("changeAuthorization", "");

          if (!stay) {
            router.push({
              name: "login"
            });
          }
        }
      });
    },
    // 获取用户地址
    changeUserAddrAsync({ commit }) {
      commit("changeLoading", true);
      return getUserAddr()
        .then(res => {
          commit("changeLoading", false);
          if (res.status == 200) {
            commit("changeUserAddr", res.data);
            commit("changeCountry", res.data);
          }
        })
        .catch(err => {
          commit("changeLoading", false);
        });
    },

    // 抽奖步骤
    // 1. 查活动 getActiveInfo
    // 2. 判断活动 statusing，等于1就调 getUserActive
    // 3. 判断 getUserActive 的返回值是否有 uniqueVoucher，没有就调 takePartIn 参加活动

    // 获取活动
    getActiveAsync({ commit }) {
      return getActiveInfo()
        .then(res => {
          if (res.status == 200) {
            commit("changeDrawInfo", res.data[0]);
          }
          return res;
        })
        .catch(err => {});
    },
    // 获取活动
    getUserActiveAsync({ state, commit, dispatch }, params) {
      return getUserActive(params)
        .then(res => {
          if (res.status == 200) {
            if (!res.data.uniqueVoucher) {
              takePartIn({
                ...params,
                status: 0
              })
                .then(res1 => {
                  if (res1.status == 200) {
                    commit("changeUserDrawInfo", res1.data);
                  }
                })
                .catch(err => {});
            } else {
              commit("changeUserDrawInfo", res.data);
            }
          }
        })
        .catch(err => {});
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js